// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__NbGdT","label":"Section_label__3qNPN","contentWrap":"Section_contentWrap__2Kfop","footer":"Section_footer__1vlgr","footerInner":"Section_footerInner__1Qbiq"};